import React, {useRef, useState} from 'react';
import {TableComponent} from "../tableComponent/tableComponent";
import {plainOptionsSpm} from "../../../common/optionsTableShares";
import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {
    bannerStatus, loadingBanners,
    selectBanner,
    selectCountProd,
    selectFilter,
    selectFilterTitle, selectSlide,
    selectSortTitle,
    selectTableContentForSpm, selectTime,
    selectZoomedTime,
    visiblePDF
} from "../../../common/selectors";
import {fetchBanners, selectParamsAC, selectSlideAC, selectSortTitleAC} from "../../../redux/tableReducer";
import {DataTableSpmResType} from "../../../common/types";
import dayjs from "dayjs";
import styles from "./tableSpm.module.sass";
import {Uploader} from "../../options/uploader/uploader";
import {Button, Popover} from "antd";
import {CloseCircleOutlined, VerticalAlignBottomOutlined} from "@ant-design/icons";
import {Spinner} from "../../../common/spin";
import {Carousel} from "../carousel/carousel";


const titleTableSpm: {[index: string]:string} = {
    name_sale: 'Наименование',
    spm: 'Супермаркет',
    average_percent: 'Размер скидки',
    count_categories: 'Категории(SKU)',
    get_date_row: 'Дата начала',
    to_date: 'Дата завершения',
}

// Компонент таблицы акций и скидок по супермаркетам
export const TableSupermarkets = () => {
    // Получаем dispatch для работы с redux
    const dispatch = useAppDispatch()

    // Получаем данные для таблицы супермаркетов
    const tableContent = useAppSelector(selectTableContentForSpm)
    // Получаем фильтр
    const filter = useAppSelector(selectFilter)
    // Получаем временной диапазон для зума
    const zoom = useAppSelector(selectZoomedTime)
    // Получаем параметры сортировки
    const sortTitle = useAppSelector(selectSortTitle)
    // Получаем выбранные супермаркеты
    const filterTitle = useAppSelector(selectFilterTitle)
    // Получаем количество товаров
    const countProd = useAppSelector(selectCountProd)
    // Получаем состояние видимости PDF
    const visible = useAppSelector(visiblePDF)
    // Получаем баннеры
    const banner = useAppSelector(selectBanner)
    // Получаем статус загрузки баннеров
    const status = useAppSelector(bannerStatus)
    // Получаем текущий слайд
    const slideState = useAppSelector(selectSlide)
    // Получаем статус загрузки
    const loading = useAppSelector(loadingBanners)
    // Получаем временной диапазон
    const time = useAppSelector(selectTime)

    // Функция сортировки по заголовку
    const sortTitleFunc = (title:string) => {
        if (sortTitle.name !== title) {
            dispatch(selectSortTitleAC({...sortTitle, name: title, direction: true}))
        }
        if (sortTitle.name === title) {
            dispatch(selectSortTitleAC({...sortTitle, name: title, direction: !sortTitle.direction}))
        }
    }

    // Фильтрация и сортировка данных таблицы
    const filteredContent = (content: DataTableSpmResType[]) => {
        return content
            .filter((el) => plainOptionsSpm.includes(el.spm))
            .filter((el) => filterTitle.includes(el.spm))
            .sort((a, b) => dayjs(b.get_date_row).valueOf() - dayjs(a.get_date_row).valueOf())
            .filter((el) => {
                return (el.get_date_row < zoom[0]! && el.to_date >= zoom[0]!) ||
                    (el.get_date_row >= zoom[0]! && el.get_date_row <= zoom[1]! && el.to_date >= zoom[0]! && el.to_date <= zoom[1]!) ||
                    (el.get_date_row <= zoom[1]! && el.to_date >= zoom[1]!)
            })
    }

    // Массив отфильтрованных данных
    const filterContent = filteredContent(tableContent)

    // Сортировка данных по выбранному столбцу
    const sortContent = (filtCont: DataTableSpmResType[]) => {
        return  filtCont
        .sort((a,b) => {
            if (sortTitle.name === 'spm' && sortTitle.direction&& a.spm !== null && b.spm !== null) {
                return  a.spm.localeCompare(b.spm)
            }
            if (sortTitle.name === 'spm' && !sortTitle.direction&& a.spm !== null && b.spm !== null) {
                return  b.spm.localeCompare(a.spm)
            }
            if (sortTitle.name === 'name_sale' && sortTitle.direction&& a.name_sale !== null && b.name_sale !== null) {
                return  a.name_sale.localeCompare(b.name_sale)
            }
            if (sortTitle.name === 'name_sale' && !sortTitle.direction&& a.name_sale !== null && b.name_sale !== null) {
                return  b.name_sale.localeCompare(a.name_sale)
            }
            if (sortTitle.name === 'average_percent' && sortTitle.direction&& a.average_percent !== null && b.average_percent !== null) {
                return  a.average_percent.localeCompare(b.average_percent)
            }
            if (sortTitle.name === 'average_percent' && !sortTitle.direction&& a.average_percent !== null && b.average_percent !== null) {
                return  b.average_percent.localeCompare(a.average_percent)
            }
            if (sortTitle.name === 'count_categories' && sortTitle.direction && a.count_categories !== null && b.count_categories !== null) {
                return  a.count_categories.localeCompare(b.count_categories)
            }
            if (sortTitle.name === 'count_categories' && !sortTitle.direction && a.count_categories !== null && b.count_categories !== null) {
                return  b.count_categories.localeCompare(a.count_categories)
            }
            if (sortTitle.name === 'to_date' && sortTitle.direction && a.dateInfo !== null && b.dateInfo !== null) {
                return  a.dateInfo.localeCompare(b.dateInfo)
            }
            if (sortTitle.name === 'to_date' && !sortTitle.direction && a.dateInfo !== null && b.dateInfo !== null) {
                return  b.dateInfo.localeCompare(a.dateInfo)
            }
            if (sortTitle.name !== 'name_sale' && sortTitle.direction) {
                return dayjs(a[sortTitle.name]).valueOf() - dayjs(b[sortTitle.name]).valueOf()
            }
            if (sortTitle.name !== 'name_sale' && !sortTitle.direction) {
                return dayjs(b[sortTitle.name]).valueOf() - dayjs(a[sortTitle.name]).valueOf()
            }
            return dayjs(a[sortTitle.name]).valueOf() - dayjs(b[sortTitle.name]).valueOf()
        })}

    // Массив отсортированных данных для таблицы
    const sortContentTab = sortContent(filterContent)

    // Состояние выбранного id
    const [id, setId] = useState(0)
    // Состояние блока поповера
    const [block, setBlock] = useState(false)
    // Состояние текущего слайда
    const [slide, setSlide] = useState<number>(0)
    // Состояние открытия поповера
    const [open, setOpen] = useState(false)

    // Обработчик клика по строке таблицы
    const onClickId = (idRow: number,
                       name_sale: string,
                       spm: string,
                       from_date: string,
                       to_date: string,
                       from_date_sale: string,
                       to_date_sale: string
    ) => {
        dispatch(fetchBanners({name_sale, spm: spm,  from_date, to_date, from_date_sale, to_date_sale}))
        dispatch(selectParamsAC({name_sale, spm: spm,  from_date, to_date, from_date_sale, to_date_sale}))
        setId(idRow)
        setSlide(0)
        setOpen(!open)
    }

    // Обработчик скрытия поповера
    const hide = () => {
        setBlock(false);
        setId(0);
    };

    // Обработчик клика по элементу таблицы
    const onClickTableItem = () => {
        setId(0);
        setBlock(!block)
    }

    // Обработчик смены слайда в карусели
    const carouselHandler = (current: number) => {
        setSlide(current)
        dispatch(selectSlideAC(current))
    }

    // Ссылка на элемент загрузчика
    const refUpload = useRef<HTMLInputElement>(null)

    // Обработчик загрузки баннера
    const uploadHandler = () => {
        refUpload.current&&refUpload.current.click()
    }
        const tableRow = sortContentTab.map((el, index) =>
            <Popover
                key={index}
                placement="left"
                content={
                    <div >
                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <div style={{width: '85%'}}>{el.name_sale}</div>
                            {/*{banner.urls[slide]&&<Uploader refUpload={refUpload}
                                                           currentBanner={banner.urls[slide]}
                                                           slide={slideState}

                            />}*/}
                            {/*<Button type={"link"} icon={<VerticalAlignBottomOutlined />} onClick={uploadHandler} />*/}
                            <Button type={"link"} icon={<CloseCircleOutlined />} onClick={hide} />
                        </div>
                        {loading === 'loading' ? <Spinner/> :
                            <Carousel data={banner} callBack={carouselHandler} slide={slideState} open={open}/>}

                    </div>

                }
                //title={el.name_sale}
                trigger="click"
                open={id === el.id &&block}
                onOpenChange={onClickTableItem}
            >
            <div key={index}  style={{backgroundColor: el.colors, color: el.text, cursor: 'pointer', opacity: id === el.id || !block ? 1 : .5}} className={styles.tableRow}>
                {/*onClick={() => onClickId(el.id, el.name_sale, el.spm, time[0], time[1], el.get_date_row.toString(), el.to_date.toString())}*/}
                <div className={styles.tableItem}>{el.name_sale}</div>
                <div className={styles.tableItem}>
                    <span
                        className={styles.titleItem}>{titleTableSpm.spm}
                    </span>

                    <span>
                        {el.spm}
                    </span>

                </div>
                <div className={styles.tableItem}>
                    <span
                        className={styles.titleItem}>{titleTableSpm.average_percent}
                    </span>
                    <span>{el.average_percent}</span>

                </div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableSpm.count_categories}</span><span>{el.count_categories}</span></div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableSpm.get_date_row}</span><span>{el.get_date_row}</span></div>
                <div className={styles.tableItem}><span
                    className={styles.titleItem}>{titleTableSpm.to_date}</span><span>{el.dateInfo}</span></div>
            </div>
            </Popover>
                )

    // ...рендер...
    return (
        <>
            <TableComponent
                name={'supermarkets'}
                titleTable={titleTableSpm}
                tableContent={tableContent}
                filter={filter}
                zoom={zoom}
                sortTitle={sortTitle}
                filterTitle={filterTitle}
                countProd={countProd}
                visible={visible}
                sortTitleFunc={sortTitleFunc}
                filteredTableContent={filterContent}
                sortTableContent={sortContentTab}
                plainOptions={plainOptionsSpm}
                tableRow={tableRow}
            />
        </>
    );
};
// ...конец файла...
